import * as React from 'react';
import * as Autosuggest from 'react-autosuggest';
import { connect } from 'react-redux';
import { ApplicationState } from 'src/store';
import { clearSuggestions, getUserAutoSuggestions } from 'src/store/user/action';
import { User, UserState } from 'src/store/user/types';
import { throttle } from 'throttle-debounce';
import './SuggestUser.scss';

interface Props {
  type: string;
  value: User | undefined;
  onSelected: any;
  onBlur: any;
  placeholder: string;
  errorClassName: any;
}

interface PropsFromDispatch {
  getAutoSuggestions: typeof getUserAutoSuggestions;
  clearSuggestions: typeof clearSuggestions;
}

interface PropsfromState {
  users: UserState;
}

interface State {
  value: '';
}

type AllProps = Props & PropsfromState & PropsFromDispatch;

class MyAutocomplete extends React.Component<AllProps, State> {
  autocompleteSearchThrottled: any;

  constructor(props: AllProps) {
    super(props);

    this.state = {
      value: ''
    };

    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
    this.fetchSuggestions = this.fetchSuggestions.bind(this);
    this.suggestionSelected = this.suggestionSelected.bind(this);
    this.onChange = this.onChange.bind(this);

    this.autocompleteSearchThrottled = throttle(500, this.fetchSuggestions);
  }

  onSuggestionsFetchRequested = ({ value }: any) => {
    this.autocompleteSearchThrottled(value);
  };

  fetchSuggestions = (value: string) => {
    if (value.length > 1) {
      this.props.getAutoSuggestions(this.props.type, value);
    }
  };

  getSuggestions = (value: string) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    const users = this.props.users.suggestions;

    return inputLength === 0
      ? []
      : users.filter(user => user.name.toLowerCase().slice(0, inputLength) === inputValue);
  };

  onSuggestionsClearRequested = () => {
    this.props.clearSuggestions();
  };

  // When suggestion is clicked, Autosuggest needs to populate the input
  // based on the clicked suggestion. Teach Autosuggest how to calculate the
  // input value for every given suggestion.
  getSuggestionValue = (suggestion: any) => {
    return suggestion.name;
  };
  renderSuggestion = (suggestion: User) => <div>{suggestion.name}</div>;

  suggestionSelected = (suggestion: any, data: any) => {
    console.log(suggestion);
    this.setState({ value: '' });
    this.props.onSelected(data.suggestion);
  };

  onChange = (event: any, { newValue }: any) => {
    console.log(event);
    this.setState({ value: newValue });
  };

  public render() {
    const { value } = this.state;
    const propValue = this.props.value;
    const { onBlur, errorClassName, placeholder } = this.props;
    const onChange = this.onChange;
    const inputProps = {
      placeholder,
      onChange,
      value,
      className: errorClassName,
      onBlur
    };
    return (
      <React.Fragment>
        <div className="selectedBusiness">{propValue && propValue.name}</div>
        <Autosuggest
          suggestions={this.props.users.suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.props.clearSuggestions}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
          onSuggestionSelected={this.suggestionSelected}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ users }: ApplicationState) => ({ users });

const mapDispatchToProps = (dispatch: any) => ({
  getAutoSuggestions: (type: string, searchString: string) =>
    dispatch(getUserAutoSuggestions(searchString, type)),
  clearSuggestions: () => dispatch(clearSuggestions())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyAutocomplete);



// WEBPACK FOOTER //
// ./src/pages/Event/EventDetail/AddParticipant/SuggestUser.tsx